import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import {
  ICommentThread,
  IPanel,
  ISuggestion,
  ITrackChange,
  IUserInfo,
  LoadingState,
  NumberedCitation,
  ReferenceEditor,
  UnnumberedCitation,
} from '../models/decorators.model';
import { initialState } from './initial.state';
import { WkTemplate } from '../../../model/wk-template-model';
import { DocumentValidationStatus } from '../../../model/validation-service.model';

export interface DecorationsState extends IPanel {
  initialLoadingState: LoadingState;
  nodeId: string;
  isEditable: boolean;
  referenceEditor: ReferenceEditor;
  isCopyEnable?: boolean;
  citationStack: NumberedCitation[][];
  unNumberedCitationStack: UnnumberedCitation[][];
  undoStackIndex: number;
  unNumRefUndoStackIndex: number;
  trackChangeData: ITrackChange;
  trackChangeRHPData: ITrackChange;
  usersInfo: IUserInfo[];
  readonlyContent?: {
    trackChangeData: {
      commentThreads: ICommentThread[];
      suggestions: ISuggestion[];
    };
    docContent?: string;
    loaded?: boolean;
  };
  citationTabIndex: number;
  isInfoDrawerToggled: boolean;
  subTemplates?: WkTemplate[];
  keywords: any[];
  selectedCommentsTabIndex: number;
  userPreferenceForTrackChangesView: string;
  documentValidationStatus: DocumentValidationStatus;
  cmTitle: string;
  baseHrefForLinkPlugin: string;
  baseHrefPathUrl: string;
  baseHrefId: string;
}

export const decorationsStateKey = 'decorations';

export const adapter: EntityAdapter<DecorationsState> =
  createEntityAdapter<DecorationsState>();

export const initialDecorationsState: DecorationsState =
  adapter.getInitialState(initialState);
